module.exports = __webpack_public_path__ + "img/timelapse.06ae70c6.svg";